import React from "react";
import StaticContentPage from "./StaticContentPage";
import { privacyPolicyText } from "../data/termsContent";

const PrivacyPolicy = () => {
  return (
    <StaticContentPage
      title="Privacy Policy"
      seoTitle="Privacy Policy | Eveness"
      seoDescription="Read the Eveness privacy policy to understand how we collect, use, protect, and manage your personal information."
      canonicalPath="/policies/privacy-policy"
    >
      {privacyPolicyText}
    </StaticContentPage>
  );
};

export default PrivacyPolicy;